import { EncryptStorage } from "encrypt-storage";

const secretKey = `${process.env.REACT_APP_SECRET_KEY}`;

export const encryptStorage = new EncryptStorage(secretKey, {
  storageType: "localStorage",
  prefix: "@UniInfo",
});
